import React, { useState } from "react"
import Universalpageheader from "../Headers/universalpageheader"
import Searchbar from "../Components/searchbar"
import { useDispatch, useSelector } from "react-redux"
import useCart from "../../hooks/useCart"
import { currencyseperator } from "../Utils/functions"
import Errorcomponent from "../Components/errorcomponent"
import Cartitem from "./cartitem"
import { Button, IconButton } from "@mui/material"
import { ChevronRight, Phone } from "@mui/icons-material"
import ProductSlider from "../Products/ProductSlider"
import { useNavigate } from "react-router-dom"
import SignIn from "../Common/login"


const Cart = () => {
    const { user, loggedIn } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const cartItems = useSelector(state => state.cartItems.data);
    const webSettings = useSelector(state => state.webSettings.data);
    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
    const favorites = useSelector(state => state.favorites.data);
    const { items, quantity, total } = useCart(cartItems);
    const subProducts = useSelector((state) => state.subProducts.data);


    const [showsearchbar, setshowsearchbar] = useState(false);
    const [showlogin, setshowlogin] = useState(false);


    const onsuccesslogin = () => {
        navigate("/checkout")
    }



    return (
        <div>
            {showlogin && <SignIn ondismiss={() => setshowlogin(false)} onsuccesslogin={onsuccesslogin} />}
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader withbackicon={true} pagename={"Cart"} onshowsearch={() => setshowsearchbar(true)} /><br />
            <div className="cartsummarytitle">CART SUMMARY</div>
            <div className='pagemini'>
                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                    <div style={{ fontWeight: "bold" }}>SubTotal</div>
                    <div>{webSettings.CURRENCY} {currencyseperator(total)}</div>
                </div>
            </div>
            {cartItems?.length < 1 && (
                <Errorcomponent error={"Items you add to shopping cart will be listed here."} />
            )}
            {cartItems?.length > 0 &&
                <div><br />
                    <div className="cartsummarytitle">CART ({cartItems.length})</div>
                    {cartItems.map((val, key) => {
                        return (
                            <Cartitem product={val} key={key} />
                        )
                    })}
                </div>
            }
            <div className='pagemini'>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="callbutton">
                        <Phone color="primary" />
                    </div>
                    <Button onClick={() => loggedIn ? navigate("/checkout") : setshowlogin(true)} disabled={cartItems?.length < 1 && true} sx={{ height: 50 }} fullWidth variant="contained" >CHECKOUT ({currencyseperator(total)})</Button>
                </div>
            </div>
            <div >
                {favorites && favorites?.length > 0 && (
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <div className="cartsummarytitle">SAVED ITEMS ({favorites.length})</div>
                            <Button onClick={() => navigate('/saveditems')} >SEE ALL</Button>
                        </section>
                        {<ProductSlider products={favorites} />}
                    </div>
                )}
                {recentlyViewed && recentlyViewed?.length > 0 && (
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <div className="cartsummarytitle">RECENTLY VIEWED</div>
                            <Button onClick={() => navigate('/recents')} >SEE ALL</Button>
                        </section>
                        {<ProductSlider products={recentlyViewed} />}
                    </div>
                )}
            </div>
        </div >
    )
}

export default Cart